module.exports = __webpack_public_path__ + "img/avatar-6.7af53a1e.jpg";